(() => {
  if (window.organiclesQuantityLimit) return;
  const LIMIT = 10;
  const MESSAGE = 'You can order up to 10 of this item.';
  const RETRY = 'We could not check your cart. Please try again.';
  const originalFetch = window.fetch.bind(window);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let queue = Promise.resolve();
  const allowedSubmits = new WeakSet();
  const allowedLinks = new WeakSet();
  const totals = items => items.reduce((result, item) => {
    const id = String(item.variant_id || item.id);
    result[id] = (result[id] || 0) + Number(item.quantity);
    return result;
  }, {});
  function notice(message) {
    let banner = document.getElementById('organicles-quantity-limit-message');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'organicles-quantity-limit-message';
      banner.setAttribute('role', 'alert');
      banner.style.cssText = 'position:fixed;bottom:20px;left:20px;right:20px;z-index:2147483647;padding:16px 20px;border:1px solid #a52323;border-radius:8px;background:#fff5f5;color:#751b1b;font-size:16px;box-shadow:0 3px 18px #0002;cursor:pointer';
      banner.addEventListener('click', () => banner.remove());
      document.body.append(banner);
    }
    banner.textContent = message;
  }
  const rejected = message => {
    notice(message);
    return new Response(JSON.stringify({ status: 422, message, description: message, errors: message }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    });
  };
  async function cart() {
    const response = await originalFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(RETRY);
    return response.json();
  }
  function decode(body) {
    if (!body) return {};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch { return decode(new URLSearchParams(body)); }
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const result = {};
      for (const [key, value] of body.entries()) {
        const itemMatch = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        const updateMatch = key.match(/^updates\[([^\]]*)\]$/);
        if (itemMatch) {
          result.items ||= [];
          result.items[Number(itemMatch[1])] ||= {};
          result.items[Number(itemMatch[1])][itemMatch[2]] = value;
        } else if (updateMatch) {
          result.updates ||= updateMatch[1] ? {} : [];
          if (updateMatch[1]) result.updates[updateMatch[1]] = value;
          else result.updates.push(value);
        } else result[key] = value;
      }
      return result;
    }
    return body;
  }
  function exceeds(items, action, data) {
    const before = totals(items);
    const next = items.map(item => ({ ...item }));
    if (action === 'add') {
      for (const entry of data.items || [data]) {
        if (!entry || !entry.id) continue;
        next.push({ variant_id: String(entry.id), quantity: Number(entry.quantity ?? 1) });
      }
    } else if (action === 'change') {
      const index = data.line ? Number(data.line) - 1 : next.findIndex(item => item.key === String(data.id) || String(item.variant_id) === String(data.id));
      if (next[index] && data.quantity !== undefined) next[index].quantity = Number(data.quantity);
    } else if (action === 'update' && data.updates) {
      if (Array.isArray(data.updates)) data.updates.forEach((quantity, index) => {
        if (next[index]) next[index].quantity = Number(quantity);
      });
      else for (const [id, quantity] of Object.entries(data.updates)) {
        const index = next.findIndex(item => item.key === id || String(item.variant_id) === id);
        if (index >= 0) next[index].quantity = Number(quantity);
        else next.push({ variant_id: id, quantity: Number(quantity) });
      }
    }
    return Object.entries(totals(next)).some(([id, quantity]) => quantity > LIMIT && quantity > (before[id] || 0));
  }
  window.organiclesQuantityLimit = { limit: LIMIT };
  window.fetch = function(input, init) {
    const url = new URL(input instanceof Request ? input.url : String(input), location.href);
    const match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
    const method = (init && init.method) || (input instanceof Request ? input.method : 'GET');
    if (url.origin !== location.origin || !match || method.toUpperCase() !== 'POST') return originalFetch(input, init);
    const task = async () => {
      let body = init && init.body;
      if (body === undefined && input instanceof Request) body = await input.clone().text();
      const data = decode(body);
      let state;
      try { state = await cart(); } catch { return rejected(RETRY); }
      if (exceeds(state.items, match[1], data)) return rejected(MESSAGE);
      return originalFetch(input, init);
    };
    const response = queue.then(task, task);
    queue = response.then(() => undefined, () => undefined);
    return response;
  };
  function inputs() {
    document.querySelectorAll('input[name="quantity"], input[name="updates[]"]').forEach(input => {
      const existing = Number(input.getAttribute('max'));
      const max = existing > 0 ? Math.min(existing, LIMIT) : LIMIT;
      input.setAttribute('max', String(max));
      input.setAttribute('data-max', String(max));
      if (!input.dataset.organiclesLimit) {
        input.dataset.organiclesLimit = 'true';
        input.addEventListener('input', () => {
          input.setCustomValidity(Number(input.value) > LIMIT ? MESSAGE : '');
        });
      }
    });
  }
  document.addEventListener('invalid', event => {
    if (event.target.matches('input[name="quantity"],input[name="updates[]"]') && Number(event.target.value) > LIMIT) notice(MESSAGE);
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (allowedSubmits.delete(form)) return;
    const url = new URL(form.action, location.href);
    const isAdd = /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    const isCart = /\/cart(?:\/update(?:\.js)?)?\/?$/.test(url.pathname);
    if ((!isAdd && !isCart) || (isAdd && form.closest('product-form'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await queue;
      const state = await cart();
      const data = decode(new FormData(form));
      if (exceeds(state.items, isAdd ? 'add' : 'update', data) || (!isAdd && Object.values(totals(state.items)).some(q => q > LIMIT) && event.submitter && event.submitter.name === 'checkout')) {
        notice(MESSAGE);
        return;
      }
      allowedSubmits.add(form);
      form.requestSubmit(event.submitter || undefined);
    } catch { notice(RETRY); }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || allowedLinks.delete(link)) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await queue;
      if (Object.values(totals((await cart()).items)).some(q => q > LIMIT)) return notice(MESSAGE);
      allowedLinks.add(link);
      link.click();
    } catch { notice(RETRY); }
  }, true);
  document.addEventListener('DOMContentLoaded', () => {
    inputs();
    new MutationObserver(inputs).observe(document.body, { childList: true, subtree: true });
  });
})();
